
import Gikam from '../../core/gikam-core.js';
import Base from '../base.js';

let defaultOptions = {
    iframe: null,
    version: null,
    fileType: null,
    fileId: null,
    fileName: null,
    fileUrl: null,
    mode: 'view',
    viewType: 'modal'
};

export default class EditorOffice extends Base {
    constructor(options) {
        super();
        this.getListeners();
        this.initialize(options, defaultOptions).init();
    }

    /**
     * @description 可配置钩子函数
     * @private
     * @memberof EditorOffice
     */
    getListeners() {
        this.listeners = {
            warn: Gikam.emptyFunction,
            error: Gikam.emptyFunction
        };
    }

    /**
     * @description 加载sunwayoffice组件
     * @private
     * @memberof sunwayoffice
     */
    loadDocEditor() {
        //监听加载状态
        this.iframe.onload = function () {
            //加载完毕初始化编辑页面
            this.iframe.contentWindow.initDocEditorPage(this.serverUrl, this.editorOfficeObj, this.officeHook);
        }.bind(this);

        //监听编辑页面无法加载时的情况
        this.iframe.onerror = function () {
            Gikam.alert(`无法找到编辑页面，请联系管理员配置文档编辑页面。`);
            this.trigger('error');
            this.destory();
        }.bind(this);
    }

    /**
     * @description 初始化组件参数
     * @private
     * @memberof sunwayoffice
     */
    async initParams () {
        //判断文件数据是否完整
        let fileDetailCompleted = true;
        //判断使用桌面模式还是移动模式
        let type = 'desktop';
        if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) type = 'mobile';

        //获取sunwayoffice服务地址
        this.serverUrl = Gikam.sunwayofficeServerUrl || '';

        if (this.options.viewType === 'iframe') {
            await this.getFileUrl().done((file) => {
                this.options.fileType = file.fileExt;
                this.options.fileId = file.id;
                this.options.fileName = file.name;
                this.options.fileUrl = file.downloadUrl;
                this.options.version = file.version || '';
                this.iframe.src = `${Gikam.IFM_CONTEXT}/static/gikam/plugin/sunwayoffice/office.html`;
            }).fail(() => {
                fileDetailCompleted = false;
                Gikam.alert(`无法获取文件信息，请联系管理员。`);
            })
        }

        if (!fileDetailCompleted) return;

        let key = this.options.fileId.toString();
        if (this.options.version) {
            key = `${key.substring(0, 16)}-V${this.options.version}`;
        } else {
            key = key.substring(0, 14);
        }

        //配置office编辑器所需参数
        this.editorOfficeObj = {
            //文档参数
            'document': {
                //文件类型
                'fileType': this.options.fileType,
                //文件ID
                'key': key,
                //文件名称
                'title': this.options.fileName,
                //文件下载地址
                'url': Gikam.IFM_CONTEXT + this.options.fileUrl
            },
            //编辑器参数
            'editorConfig': {
                'callbackUrl': `${Gikam.IFM_CONTEXT}/open/core/module/item/files/sunwayoffices/${this.options.fileId}/action/invoke`,
                ///编辑模式（view : 查看 | edit : 编辑）
                'mode': this.options.mode || 'view'
            },
            'type': type
        };

        if (window.workspace.user.userName) this.editorOfficeObj.editorConfig.user = {'name':  window.workspace.user.userName};
        this.loadDocEditor();
    }

    /**
     * @description 获取文件信息
     * @private
     * @memberof EditorOffice
     */
    getFileUrl = function() {
        return Gikam.getJson(Gikam.IFM_CONTEXT + '/core/module/item/files/' + this.options.fileId);
    }

    /**
     * @description 初始化iframe容器
     * @private
     * @memberof sunwayoffice
     */
    initEditorContainer() {
        if (this.options.viewType === 'modal') {
            this.modal = Gikam.create('modal', {
                title: '文档编辑',
                src: '/static/gikam/plugin/sunwayoffice/office.html'
            });

            this.iframe = this.modal.getIframeDom();
        } else if (this.options.viewType === 'iframe') {
            this.iframe = this.options.iframe;
        }
    }

    /**
     * @description 初始化sunwayoffice自用钩子函数
     * @private
     * @memberof sunwayoffice
     */
    initOfficeHookFunction () {
        let _this = this;
        //组件错误时调用
        let errorFunc = function (event) {
            if (event.data.errorCode == -4) {
                Gikam.alert(`文件无法下载，请联系管理员。`);
            } else {
                Gikam.alert(`文件服务异常，请联系管理员配置文档编辑功能。`);
            }
            
            Gikam.error(`错误代码: ${event.data.errorCode} -------- 错误信息: ${event.data.errorDescription}`);
            _this.trigger('error', event);
            _this.destory();
        };

        //组件警告时调用
        let warningFunc = function (event) {
            Gikam.warn(`警告代码: ${event.data.warningCode} -------- 警告信息: ${event.data.warningDescription}`);
            _this.trigger('warn', event);
            if (event.data.warningCode === -101) {
                Gikam.alert(`文件无法保存，请联系管理员。`);
                _this.destory();
            } 
            /*else if (event.data.warningCode == -18) {
                 Gikam.alert(`与服务器断开连接，请您刷新重试。`);
            }*/
        }

        //无法获取sunwayoffice服务器api.js时调用
        let onScriptErrot = function () {
            Gikam.alert(`无法连接文件服务器，请联系管理员配置文档编辑功能。`);
            _this.trigger('error');
            _this.destory();
        }

        //将应用程序加载到浏览器时调用的函数
        let onAppReady = Gikam.emptyFunction;
        //将文档加载到文档编辑器中时调用的函数
        let onDocumentReady = Gikam.emptyFunction;
        //修改文档时调用的函数
        let onDocumentStateChange  = Gikam.emptyFunction;

        this.officeHook = {
            onError: errorFunc,
            onWarning: warningFunc,
            onScriptErrot: onScriptErrot,
            onAppReady: onAppReady,
            onDocumentReady: onDocumentReady,
            onDocumentStateChange: onDocumentStateChange
        }
    }

    init() {
        this.initOfficeHookFunction();
        this.initEditorContainer();
        this.initParams();
    }

    /**
     * @description 关闭编辑页面
     * @private
     * @memberof sunwayoffice
     */
    destory() {
        if (this.modal) this.modal.close();
    }
}